module.exports = {
	init() {
		const button = this.root.getElementsByClassName(
			'box-article-content--category',
		)[0];
		const readArticle = this.root.getElementsByClassName(
			'box-article-content--link',
		)[0];

		if (button) {
			button.addEventListener('mouseover', () => {
				readArticle.classList.add('noHover');
			});
			button.addEventListener('mouseout', () => {
				readArticle.classList.remove('noHover');
			});
		}
	},
};
